<fui-modal [maxHeight]="'650px'" [maxWidth]="'650px'" [state]="state">
    <fui-modal-window>
        <fui-modal-window-toolbar (closed)="cancel()"
                                  [title]="isForItem ? 'wbo.sales-journal.edit.heading.itemRefund' : 'wbo.sales-journal.edit.heading.paymentRefund'">
        </fui-modal-window-toolbar>
        <fui-modal-window-main>
            <fui-rows>
                <fui-row>
                    <fui-column>
                        <wbo-currency-edit-control [(ngModel)]="paymentTotal"
                                                   [ngModelOptions]="{standalone: true}"
                                                   [readonly]="true"
                                                   label="wbo.sales-journal.edit.field.paymentRefund.paymentTotal.label"></wbo-currency-edit-control>
                        <wbo-currency-edit-control *ngIf="paymentTotal !== remainingAmount"
                                                   [(ngModel)]="remainingAmount"
                                                   [ngModelOptions]="{standalone: true}"
                                                   [readonly]="true"
                                                   label="wbo.sales-journal.edit.field.paymentRefund.remainingAmount.label"></wbo-currency-edit-control>
                        <fui-tandem-field *ngIf="isForItem">
                            <wbo-numeric-edit-control [(ngModel)]="itemQty"
                                                      [ngModelOptions]="{standalone: true}"
                                                      [readonly]="true"
                                                      label="wbo.sales-journal.edit.field.paymentRefund.itemQty.label"></wbo-numeric-edit-control>
                            <wbo-currency-edit-control [(ngModel)]="itemPrice"
                                                       [ngModelOptions]="{standalone: true}"
                                                       [readonly]="true"
                                                       label="wbo.sales-journal.edit.field.paymentRefund.itemPrice.label"></wbo-currency-edit-control>
                        </fui-tandem-field>
                        <fui-tandem-field *ngIf="isForItem">
                            <wbo-numeric-edit-control *ngIf="itemRefundedQty" [(ngModel)]="itemRefundedQty"
                                                      [ngModelOptions]="{standalone: true}"
                                                      [readonly]="true"
                                                      label="wbo.sales-journal.edit.field.paymentRefund.itemRefundedQty.label"></wbo-numeric-edit-control>
                            <div class="quantity-spinner">
                                <fui-mark-button *ngIf="canDecrementRefundQty || canIncrementRefundQty"
                                                 class="quantity-spinner-button" [disabled]="!canDecrementRefundQty"
                                                 (click)="decrementRefundQty()">
                                    <fui-icon icon="remove" height="20" width="20"></fui-icon>
                                </fui-mark-button>
                                <div class="quantity-spinner-value">
                                    <wbo-numeric-edit-control [(ngModel)]="refundQty"
                                                              [ngModelOptions]="{standalone: true}"
                                                              [readonly]="true"
                                                              label="wbo.sales-journal.edit.field.paymentRefund.refundQty.label"></wbo-numeric-edit-control>
                                </div>
                                <fui-mark-button *ngIf="canDecrementRefundQty || canIncrementRefundQty"
                                                 class="quantity-spinner-button" [disabled]="!canIncrementRefundQty"
                                                 (click)="incrementRefundQty()">
                                    <fui-icon icon="plus" height="20" width="20"></fui-icon>
                                </fui-mark-button>
                            </div>
                        </fui-tandem-field>
                        <wbo-currency-edit-control *ngIf="remainingAmount > 0"
                                                   [(ngModel)]="refundAmount"
                                                   [ngModelOptions]="{standalone: true}"
                                                   [readonly]="isForItem"
                                                   label="wbo.sales-journal.edit.field.paymentRefund.refundAmount.label"></wbo-currency-edit-control>
                    </fui-column>
                </fui-row>
            </fui-rows>
        </fui-modal-window-main>
        <fui-modal-window-footer>
            <fui-buttons>
                <wbo-cancel-button (click)="cancel()"></wbo-cancel-button>
                <wbo-ok-button (click)="confirm()" *ngIf="remainingAmount > 0" [disabled]="!refundAmount || refundAmount > remainingAmount"
                               [title]="'wbo.sales-journal.edit.button.processRefund'" ></wbo-ok-button>
            </fui-buttons>
        </fui-modal-window-footer>
    </fui-modal-window>
</fui-modal>
